import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const useMinimumRefreshInterval = () => {
  const { data, isInitialLoading } = useQuery({
    queryKey: ["system", "configuration", "minimum-refresh-interval"],
    queryFn: () => defaultOnError(
      fetch("GET", qualifyUrl("/system/configuration/minimum_auto_refresh_interval")),
      i18n.t("save_view_notifications.load_minimum_refresh_interval_failed", { ns: "search" }),
      i18n.t("save_view_notifications.could_not_load_configuration", { ns: "search" })
    )
  });
  return { data: data == null ? void 0 : data.value, isInitialLoading };
};
export default useMinimumRefreshInterval;
